export default {
  computed: {
    layout() {
      return this.$route.params.layout
    },
    isExploreLayout() {
      return this.layout === 'explore'
    },
    isEmbedded() {
      return this.layout === 'embedded'
    },
    isPrintable() {
      return this.layout === 'print'
    },
    isThumbnail() {
      return this.layout === 'thumbnail'
    },
  },
}
